import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MENU_OPTIONS, NAVBAR_OPTIONS } from '../../helpers/options/options'
import { MenuItem, MenuList } from '@mui/material'

type MenuSidebarProps = {
  principal: boolean
  handleHide: (hide: boolean) => void
}

type MenuOption = {
  to: string
  label: string
  background?: string
  img: string
  imgActive: string
  item: string
}

type MenuItemOption = {
  label: string
  to: string
  class: string
  section: string
}

const MenuSidebar = ({ principal, handleHide }: MenuSidebarProps) => {
  const { t } = useTranslation()
  let location = useLocation()
  const path = location.pathname
  let navigate = useNavigate()
  const [indexActive, setIndexActive] = useState(-1)
  const [showMenu, setShowMenu] = useState(false)

  const goTo = (view: string) => {
    handleHide(false)
    navigate(view)
  }

  const handleMenuShow = (index: number) => {
    setShowMenu(!showMenu)
    setIndexActive(index)
  }

  const handleActive = (index: number) => {
    setShowMenu(false)
    setIndexActive(index)
  }

  const handleInactive = () => {
    setIndexActive(-1)
  }

  const Menu = () => {
    return (
      <div className={`container-option-extra-qr-link`}>
        <button
          className="button-option-extra"
          onClick={() => goTo('create-new-link')}
        >
          <span className="option-extra">{`${t('LINK')}`}</span>
        </button>
        <hr></hr>
        <button
          className="button-option-extra"
          onClick={() => goTo('create-new-qr-code')}
        >
          <span className="option-extra">{`${t('QR_CODE')}`}</span>
        </button>
      </div>
    )
  }

  return (
    <>
      <nav className={`${'sidebar open'} right`}>
        <div className='sidebar-items-container'>
        
          {!principal ? (
            <MenuList className='nav-items'>
              {MENU_OPTIONS.map((value: MenuItemOption, index: number) => {
                return (
                  <MenuItem
                    id={`MenuItem-${index}-hamburger`}
                    className='nav-item'
                    key={`MenuItem-${index}`}
                    onClick={() => goTo(`${value.to}`)}
                  >
                    {`${t(value.label)}`}
                  </MenuItem>
                )
              })}

              <hr className='hr' />
              <div className='internal-menu'>
                <MenuItem
                  id={`MenuItem-help-hamburger`}
                  className='nav-item center'
                  onClick={() => goTo('/login')}
                >{`${t('LOGIN')}`}</MenuItem>
                <MenuItem
                  id={`MenuItem-help-hamburger`}
                  className='nav-item center'
                  onClick={() => goTo('/sign-up')}
                >
                  {`${t('SIGN_UP')}`}
                </MenuItem>

                <MenuItem
                  id={`MenuItem-help-hamburger`}
                  className='nav-item center button'
                  onClick={() => goTo('/plans')}
                >
                  {`${t('GET_A_QUOTE')}`}
                </MenuItem>
              </div>
            </MenuList>
          ) : (
            <div className='menu'>
              <div className='content'>
                {NAVBAR_OPTIONS.map((value: MenuOption, index: number) => {
                  return (
                    <div key={value.item}>
                      {value.to === '/settings' && <hr></hr>}
                      <div
                        key={index}
                        className={`menu-item margin-bottom-0 menu-open-rounded ${
                          value.to === path ? value.background : ''
                        }`}
                        onMouseOver={() => handleActive(index)}
                        onMouseOut={() => handleInactive()}
                        onClick={() =>
                          value.item === 'create_new'
                            ? handleMenuShow(index)
                            : goTo(`${value.to}`)
                        }
                      >
                        <div className='icon-container'>
                          <>
                            <img
                              className='icon'
                              src={value.imgActive}
                              alt={value.item}
                            ></img>
                            <span className='navbar-icon' title={value.item}>
                              {`${t(value.label)}`}
                            </span>
                          </>
                        </div>
                      </div>
                      {showMenu && index === 0 && <Menu />}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  )
}
export default MenuSidebar
